import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// depreciation_entries — รายการค่าเสื่อมราคา (Depreciation Entry)
// ============================================================================
export const depreciationEntries = sqliteTable("accounting_depreciation_entries", {
  id: text("id").primaryKey(), // ULID
  fixedAssetId: text("fixed_asset_id").notNull(),
  companyId: text("company_id").notNull(),
  postingDate: text("posting_date").notNull(),
  amount: real("amount").notNull().default(0),
  accumulatedAmount: real("accumulated_amount").notNull().default(0),
  journalEntryId: text("journal_entry_id"),  // FK to journal_entries
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at"),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  de_asset_idx: index("de_asset_idx").on(table.fixedAssetId),
  de_company_date_idx: index("de_company_date_idx").on(table.companyId, table.postingDate),
}));

// Type exports
export type DepreciationEntry = typeof depreciationEntries.$inferSelect;
export type NewDepreciationEntry = typeof depreciationEntries.$inferInsert;
